import { formatIsoDateBR } from "~/utils/format";

const KNOWN_MESSAGES = {
  "Advance Payment Status is not Waiting Suppluer Company Input Vacancies Data":
    "Este pacote já foi enviado ou mudou de situação. Atualize a lista.",
  "Didn't Complete Input Vacancies Data":
    "Ainda há plantões sem revisão. Marque todos como revisados antes de enviar.",
  "You will not advance any vacancy":
    "Todos os plantões estão como “Não antecipar”. Libere pelo menos um para enviar.",
  "Vacancy without Normal Payment Date":
    "Há plantão sem data de pagamento normal. Preencha a data e tente de novo.",
};

// 422 do validador do AdonisJS: { errors: [{ rule, field, message: "<rule> validation failed" }] }.
// A message padrão é inglês cru; vira um texto curto em pt-BR. Mensagens customizadas passam como vieram.
const VALIDATION_RULE_TEXT = {
  required: "é obrigatório",
  enum: "tem um valor não aceito",
  enumSet: "tem um valor não aceito",
};
const validationMessage = (item) => {
  if (!item || typeof item.message !== "string") return null;
  const { rule, field, message } = item;
  if (rule && field && message === `${rule} validation failed`) {
    return `Dados inválidos: o campo “${field}” ${VALIDATION_RULE_TEXT[rule] || "não está no formato esperado"}.`;
  }
  return message;
};

export const isCanceledRequest = (error) =>
  error?.name === "CanceledError" || error?.code === "ERR_CANCELED";

export const getApiErrorCode = (error) => error?.response?.data?.code ?? null;

export const getMergedIntoId = (error) => {
  const value = Number(error?.response?.data?.mergedIntoAdvancePaymentId);
  return Number.isInteger(value) && value > 0 ? value : null;
};

export const getApiReasons = (error) =>
  Array.isArray(error?.response?.data?.reasons) ? error.response.data.reasons : [];

export const getApiErrorMessage = (error, fallback) => {
  if (!error || !error.isAxiosError) return fallback;
  if (!error.response) {
    if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") {
      return "O servidor do Antecipe não respondeu (tempo esgotado).";
    }
    return "Não foi possível falar com o servidor do Antecipe. Verifique a conexão e tente de novo.";
  }
  const data = error.response.data || {};
  let raw = null;
  if (typeof data.message === "string" && data.message.trim()) raw = data.message.trim();
  else if (Array.isArray(data.errors)) raw = validationMessage(data.errors[0]);
  if (!raw) return fallback;
  const text = KNOWN_MESSAGES[raw] || raw;
  return data.code === "MISSING_NORMAL_PAYMENT_DATE" ? `${text}${missingDateDetail(data.vacancies)}` : text;
};

// MISSING_NORMAL_PAYMENT_DATE: o BE lista os plantões (id do VAP, data, hospital) para a tela apontar quais preencher.
const missingDateDetail = (vacancies) => {
  if (!Array.isArray(vacancies) || !vacancies.length) return "";
  const shown = vacancies.slice(0, 5).map((v) => {
    const info = [formatIsoDateBR(v.date), v.hospitalName].filter(Boolean).join(", ");
    return info ? `#${v.vacancyAdvanceId} (${info})` : `#${v.vacancyAdvanceId}`;
  });
  const rest = vacancies.length - shown.length;
  const label = vacancies.length === 1 ? "Plantão" : "Plantões";
  return ` ${label}: ${shown.join(", ")}${rest > 0 ? ` e mais ${rest}` : ""}.`;
};
